<template>
  <div>
    <el-dialog :visible.sync="visible" width="1300px" title="直播商品" @close="handleClose" append-to-body custom-class="live-goods-dialog">
      <div class="dialog-content-wrapper">
        <span class="tip-red">修改了直播的商品任何操作，需点击下清除直播商品缓存按钮，这样app端商品才会更新显示</span>
        <div style="margin-top: 12px;">
          <el-button type="primary" @click="showAddDialog" size="small" round>+ 添加商品</el-button>
          <el-button v-if="canManageIntent" type="primary" @click="showAddIntentDialog" size="small" round>+ 添加直播意向金</el-button>
          <el-button type="primary" @click="showAddActivity" size="small" round>+ 添加充值活动</el-button>
          <el-button type="primary" @click="clearLiveGoodsCache" size="small" round>清除直播商品缓存</el-button>
        </div>
        <div class="table-wrapper">
          <el-table :data="list" style="width: 100%; margin-top: 20px;" max-height="500">
          <el-table-column prop="linkId" label="链接编号" fixed="left" />
          <el-table-column label="商品图" width="60" fixed="left">
            <template slot-scope="{row}">
              <img :src="row.imgUrl" alt="" style="width: 40px; height: 40px; border-radius: 4px;" />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="商品名称"  width="150" fixed="left"/>
          <el-table-column prop="type" label="商品类型">
            <template slot-scope="{row}">
              {{ row.type === 1 ? '产品商城' : row.type === 2 ? '秒杀' : row.type === 3 ? '充值活动' : row.type === 4 ? '直播意向金' : '未识别类型' }}
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" />
          <el-table-column label="金额（元）">
            <template slot-scope="{row}">{{ row.type === 4 ? intentMoney(row.price) : row.price }}</template>
          </el-table-column>
          <el-table-column prop="canBuy" label="是否允许购买">
            <template slot-scope="{row}">
              {{ row.canBuy ? '允许购买' : '不允许购买' }}
            </template>
          </el-table-column>
          <el-table-column prop="onTime" label="上架时间" min-width="180">
            <template slot-scope="{row}">
              {{ formatTime(row.onTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="showTime" label="持续时间" />
          <!-- <el-table-column prop="offTime" label="倒计时下架" /> -->
          <!-- <el-table-column  label="获得金额" >
            <template slot-scope="{row}">
              {{ handleSubtr(row.getBalance, row.getXdbMoney) }}
            </template>
          </el-table-column> -->
          <el-table-column label="虚拟销售量"><template slot-scope="{row}">{{ row.type === 4 ? '-' : row.salesCount }}</template></el-table-column>
          <el-table-column label="剩余名额"><template slot-scope="{row}">{{ row.type === 4 ? '-' : row.remainingQuota }}</template></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="{row}">
              <el-tag v-if="row.state" type="success">上架中</el-tag>
              <el-tag v-else type="info">已下架</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="offTime" label="下架时间" min-width="180">
            <template slot-scope="{row}">
              {{ formatTime(row.offTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" fixed="right">
            <template slot-scope="{row}">
              <el-link type="primary" class="action-link" @click="updateLiveGoods(row)" v-if="row.type === 1 || row.type === 2">修改虚拟销售量</el-link>
              <el-link v-if="row.type === 4 && canViewIntent" type="primary" class="action-link" @click="viewIntentConfig(row)">查看配置</el-link>
              <el-link type="primary" class="action-link" @click="updateLiveTuition(row)" v-if="row.type === 3">修改剩余名额</el-link>
              <el-link v-if="row.type !== 4 || canManageIntent" type="primary" class="action-link" @click="handleDown(row)">{{row.state ? '下架' : '上架'}}</el-link>
              <el-link type="info" class="action-link" @click="handleRecommend(row)" v-if="canShowRecommendButton && (row.type !== 4 || canManageIntent)">{{row.ingShowTime?'取消推荐':'设为推荐'}}</el-link>
              <el-link type="danger" class="action-link" @click="handleBuy(row)" v-if="row.type !== 3 && (row.type !== 4 || canManageIntent)">{{ row.canBuy  ? '不允许购买' : '允许购买' }}</el-link>
              <el-link v-if="row.type !== 4 || canManageIntent" type="primary" class="action-link" @click="updateSort(row)">修改排序</el-link>
              <el-link type="danger" class="action-link" @click="handleDelete(row)" v-if="isPreviewState && (row.type !== 4 || canManageIntent)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="formVisible" width="600px" :title="modelType ? '添加商品' : '上架'" append-to-body>
      <el-form ref="dataForm" :model="form" label-width="120px">
        <el-form-item label="商品类型" required v-if="modelType === 1">
          <el-radio-group v-model="form.goodsType" @change="handleGoodsTypeChange" :disabled="loading">
            <el-radio :label="1" :disabled="loading">产品商城</el-radio>
            <el-radio :label="2" :disabled="loading">秒杀</el-radio>
            <el-radio v-if="canManageIntent" :label="4" :disabled="loading">直播意向金</el-radio>
          </el-radio-group>
          <div v-if="loading" style="margin-top: 5px; color: #409EFF; font-size: 12px;">
            <i class="el-icon-loading"></i> 正在加载商品列表...
          </div>
        </el-form-item>
        <el-form-item label="链接编号" v-if="modelType === 1">
          <el-input v-model="form.linkId" placeholder="请输入链接编号" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="商品" required v-if="modelType === 1">
          <el-select v-if="form.goodsType !== 4" v-model="form.goodsId" placeholder="请选择商品" style="width: 100%;" filterable :loading="loading">
            <el-option v-for="item in filteredGoodsOptions" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <el-select v-else v-model="form.intentConfigId" placeholder="搜索已启用的意向金配置" style="width:100%" filterable remote :remote-method="searchIntentConfigs" :loading="intentLoading">
            <el-option v-for="item in intentOptions" :key="item.id" :label="item.productName + ' / ' + item.configName" :value="item.id" />
          </el-select>
          <el-alert v-if="form.goodsType === 4 && intentError" :title="intentError" type="error" :closable="false" />
          <el-card v-if="form.goodsType === 4 && selectedIntent" shadow="never" style="margin-top:10px"><img :src="selectedIntent.imgUrl" style="width:48px;height:48px;vertical-align:middle;margin-right:10px" />{{ selectedIntent.productName }} · ¥{{ intentMoney(selectedIntent.amount) }}<p v-if="selectedIntent.meetingDays != null && selectedIntent.joinDays != null">仅普通用户现金购买，支付成功起 {{ selectedIntent.meetingDays }} 天内参加专题课的，会议结束后 {{ selectedIntent.joinDays }} 天内用于本人加盟抵扣；未参会的 {{ selectedIntent.meetingDays + selectedIntent.joinDays }} 天内可用。一笔使用一次。</p><p v-else>仅普通用户现金购买，支付成功起 {{ selectedIntent.validDays }} 天内用于本人加盟抵扣，一笔使用一次。</p><span>金额、封面、名称与期限沿用售卖配置，不在此处修改。</span></el-card>
        </el-form-item>
        <el-form-item label="上架持续时间" required>
          <el-input v-model="form.showTime" placeholder="请输入上架持续时间" style="width: 100%;">
            <template slot="append">分钟</template>
          </el-input>
          <span style="font-size: 12px; color: red;">不输入等于不设置，一直上架</span>
          <p v-if="form.goodsType === 4" style="font-size:12px;color:#909399">上架时长只控制直播展示，券的期限从支付成功起算。</p>
        </el-form-item>
        <el-form-item label="购买权限" required>
          <el-radio-group v-model="form.canBuy">
            <el-radio :label="1">允许购买</el-radio>
            <el-radio :label="0">不允许购买</el-radio>
          </el-radio-group>
          <p v-if="form.goodsType === 4" style="font-size:12px;color:#909399">允许购买仍仅限普通用户现金购买。</p>
        </el-form-item>
        <el-form-item label="上下架" required>
          <el-radio-group v-model="form.state" :disabled="modelType === 0 && form.goodsType === 4">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort" placeholder="请输入排序" style="width: 100%;" type="number" :disabled="modelType === 0 && form.goodsType === 4" />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            <i class="el-icon-info"></i> 数值越小越靠前
          </div>
        </el-form-item>

      </el-form>
      <div style="text-align: right; margin-top: 30px;">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="addActivityFormVisible" width="600px" title="添加充值活动" append-to-body close-on-click-modal>
      <el-form ref="activityForm" :model="activityForm" :rules="activityFormRules" label-width="100px">
        <el-form-item label="充值套餐" prop="rechargeActivityId" required>
          <el-select v-model="activityForm.rechargeActivityId" placeholder="请选择充值套餐" style="width: 100%;" >
            <el-option v-for="item in activityList" :key="item.id" :label="item.activityName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="链接编号" prop="linkId" required>
          <el-input v-model="activityForm.linkId" placeholder="请输入链接编号" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="剩余名额" prop="remainingQuota" required>
          <el-input v-model="activityForm.remainingQuota" placeholder="请输入剩余名额" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="上下架" required>
          <el-radio-group v-model="activityForm.state">
            <el-radio :label="1">上架</el-radio>
            <el-radio :label="0">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="activityForm.sort" placeholder="请输入排序" style="width: 100%;" type="number" />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            <i class="el-icon-info"></i> 数值越小越靠前
          </div>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 30px;">
        <el-button @click="addActivityFormVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreateActivity()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import sysGoodsApi from '@/api/goods/sysGoods'
import rechargeActivityApi from '@/api/recharge/rechargeActivity'
import intentApi from '@/api/live/intentDeposit'
import { hasIntentPermission, intentPermissions, intentRows, intentMoney } from '@/utils/intent-deposit'
import { Subtr } from '@/utils/index'
function initFormBean() {
  const formBean = {
    canBuy: null,
    goodsId: null,
    intentConfigId: null,
    goodsType: 1, // 默认选中产品商城
    linkId: '', // 链接编号
    liveId: null,
    onTime: new Date().toISOString().slice(0, 19).replace('T', ' '), // 当前时间
    showTime: null,
    sort: 100,
    state: 1, // 默认上架
  }
  return formBean
}
function initActivityFormBean() {
  const activityFormBean = {
    linkId: '', // 链接编号
    rechargeActivityId: null,
    remainingQuota: null,
    sort: 100,
    state: 1, // 默认上架
  }
  return activityFormBean
}
export default {
  data() {
    return {
      activityForm: initActivityFormBean(),
      activityFormRules: {
        rechargeActivityId: [
          { required: true, message: '请选择充值套餐', trigger: 'change' }
        ],
        linkId: [
          { required: true, message: '请输入链接编号', trigger: 'blur' }
        ],
        remainingQuota: [
          { required: true, message: '请输入剩余名额', trigger: 'blur' }
        ]
      },
      form: initFormBean(),
      visible: false,
      formVisible: false,
      list: [],
      query: {
        liveId: null
      },
      goodsOptions: [],
      loading: false,
      modelType: 1,
      addActivityFormVisible: false,
      activityList: [],
      goodsItem: null,
      isRepSub: false,
      previousGoodsType: 1, // 保存上一次的商品类型，用于防重复点击
      goodsSequence: 0,
      intentOptions: [], intentLoading: false, intentLoaded: false, intentError: '', intentSequence: 0,
    }
  },
  computed: {
    canViewIntent() { return hasIntentPermission(this.$store, intentPermissions.configView) },
    canManageIntent() { return this.canViewIntent && hasIntentPermission(this.$store, intentPermissions.configEdit) },
    selectedIntent() { return this.intentOptions.find(row => String(row.id) === String(this.form.intentConfigId)) },
    // 判断是否显示推荐按钮：只有在直播中(state=1)和直播暂停(state=2)状态下才显示
    canShowRecommendButton() {
      if (!this.rowItem || !this.rowItem.livePO) {
        return false
      }
      const liveState = this.rowItem.livePO.state
      // state 1: 直播中, state 2: 直播暂停
      
      return liveState === 1 || liveState === 2
    },
    // 判断是否为预告状态：只有预告中(state=0)才显示删除按钮
    isPreviewState() {
      if (!this.rowItem || !this.rowItem.livePO) {
        return false
      }
      const liveState = this.rowItem.livePO.state
      // state 0: 预约直播（预告）
      return liveState === 0
    },
    // 本地筛选商品选项
    filteredGoodsOptions() {
      return this.goodsOptions
    }
  },
  created() {
    this.getActivityList()
  },
  methods: {
    intentMoney,
    mountParams(row, params) { return row.type === 4 ? { ...params, goodsType: 4 } : params },
    async searchIntentConfigs(keyword = '') {
      if (!this.canManageIntent) return
      const sequence = ++this.intentSequence; this.intentLoading = true; this.intentLoaded = false; this.intentError = ''
      try { const res = await intentApi.configs({ keyword, enabled: true, pageNo: 1, pageSize: 50 }); if (sequence !== this.intentSequence) return; this.intentOptions = intentRows(res.data).filter(row => row.enabled === true); this.intentLoaded = true }
      catch (e) { if (sequence === this.intentSequence) { this.intentOptions = []; this.intentError = e.message || '意向金配置加载失败，请重新搜索' } }
      finally { if (sequence === this.intentSequence) this.intentLoading = false }
    },
    viewIntentConfig(row) { if (this.canViewIntent && row.intentConfigId) { this.visible = false; this.$router.push({ path: '/live/intentDepositConfig', query: { configId: String(row.intentConfigId) } }) } },
    handleSubtr(a, b) {
      return Subtr(a, b)
    },
    formatTime(timeStr) {
      if (!timeStr) return '-'
      // 将 "2025-10-10T09:03:09" 格式转换为 "2025-10-10 09:03:09"
      return timeStr.replace('T', ' ')
    },
    getActivityList() {
      rechargeActivityApi.fetchList({pageNo: 1, pageSize: 10, rewardType: '', isLimit: '', state: true,activityType:1}).then((data) => {
        this.activityList = data.data.list
      })
    },
    showAddActivity() {
      this.getActivityList()
      this.activityForm = initActivityFormBean() // 重新初始化表单
      this.addActivityFormVisible = true
    },
    doCreateActivity() {
      this.$refs["activityForm"].validate((valid) => {
        if (valid) {
          // 添加当前选中的直播ID
          const params = {
            ...this.activityForm,
            liveId: this.rowItem.livePO.id
          }
         
          liveManageApi.createLiveGoodsActivity(params).then((data) => {
            this.isRepSub = false
            this.$message.success('操作成功')
            // 关闭添加充值活动弹窗
            this.addActivityFormVisible = false;
            liveManageApi.clearLiveGoodsCache({ liveId: this.rowItem.livePO.id })
            // 不关闭商品列表弹窗，保持显示
            // this.visible 保持为 true
            // 刷新商品列表数据
            this.doQueryList()
            this.$emit('created')
          }).catch(res => {
            this.isRepSub = false
          })
        }
      })
    },
    searchGoods(goodsType) {
      // 只在切换商品类型时请求接口，不进行名称筛选
      const currentGoodsType = goodsType !== undefined ? goodsType : this.form.goodsType
      const sequence = ++this.goodsSequence
      let params = {
        pageNo: 1,
        pageSize: 1000,
        state: 1,
        isShowApp: 1,
        // 根据商品类型设置不同的区域ID列表
        areaIdList: currentGoodsType === 1 ? '3,4,5' : '1'
      }
      this.loading = true
      sysGoodsApi.fetchList(params).then(res => {
        if (sequence !== this.goodsSequence) return
        this.goodsOptions = res.data.list;
      }).finally(() => {
        if (sequence !== this.goodsSequence) return
        this.loading = false
      })
    },
    handleGoodsTypeChange(value) {
      console.log('商品类型切换:', value, '当前表单类型:', this.form.goodsType)
      // 如果正在加载中，阻止切换
      if (this.loading) {
        this.$message.warning('商品列表正在加载中，请稍候...')
        // 恢复原来的值
        this.$nextTick(() => {
          this.form.goodsType = this.previousGoodsType
        })
        return
      }
      // 保存当前值作为备用
      this.previousGoodsType = value
      // 清空已选商品
      this.form.goodsId = null
      this.form.intentConfigId = null
      // 清空商品选项列表
      this.goodsOptions = []
      // 重新搜索对应类型的商品，传递当前选中的商品类型
      if (value === 4) { this.form.canBuy = 1; this.searchIntentConfigs('') }
      else { ++this.intentSequence; this.intentLoaded = false; this.searchGoods(this.form.goodsType) }
    },
    handleShow(row) {
      this.rowItem = { ...row }
      this.doQueryList()
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    doQueryList() {
      this.listLoading = true
      this.query.liveId = this.rowItem.livePO.id
      this.query.includeIntent = this.canViewIntent
      return liveManageApi.fetchListLiveGoods(this.query).then(res => {
       // console.log('接口返回数据:', res);
        // 接口直接返回数组，不是包含list的对象
        this.list = res.data;
       // console.log('列表数据:', this.list);
      }).finally(() => {
        this.listLoading = false
      })
    },
    showAddDialog() {
      this.modelType = 1
      this.form = initFormBean()
      this.goodsOptions = []
      // 默认加载产品商城商品
      this.searchGoods(1)
      this.formVisible = true
    },
    showAddIntentDialog() {
      if (!this.canManageIntent || this.isRepSub) return
      ++this.goodsSequence
      this.loading = false
      this.modelType = 1
      this.form = initFormBean()
      this.form.goodsType = 4
      this.form.canBuy = 1
      this.previousGoodsType = 4
      this.goodsOptions = []
      this.formVisible = true
      this.searchIntentConfigs('')
    },
    handleBuy(row) {
      if (row.type === 4 && !this.canManageIntent) return
      this.$common.confirm(`${row.canBuy ? '确认不允许购买' : '确认允许购买'}`)
        .then(() => liveManageApi.updateLiveGoodsSetcanBuy(this.mountParams(row, { id: row.id, canBuy: row.canBuy ? 0 : 1 })))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ })
        })
    },
    handleRecommend(row) {
      if (row.type === 4 && !this.canManageIntent) return
      const isRecommended = row.ingShowTime
      const actionText = isRecommended ? '取消推荐' : '设为推荐'
      const ingShowTime = isRecommended ? 0 : 1
      
      this.$common.confirm(`是否确认${actionText}`)
        .then(() => {
          // 根据商品类型选择不同的API
          let recommendPromise
          if (row.type === 3) {
            // 充值活动使用 livetuition-ingShowTime 接口
            recommendPromise = liveManageApi.updateLiveActivityShowTime({ id: row.id, liveId: this.rowItem.livePO.id, ingShowTime })
          } else {
            // 普通商品使用 livegoods-ingShowTime 接口
            recommendPromise = liveManageApi.updateLiveGoodsSetingShowTime(this.mountParams(row, { id: row.id, liveId: this.rowItem.livePO.id, ingShowTime }))
          }
          
          // 如果设置为推荐，需要更新排序
          if (ingShowTime === 1) {
            // 循环商品列表，找出最小的排序号（如果有多个商品具有相同的最小排序号，取其中一个即可）
            let minSort = Infinity
            this.list.forEach(item => {
              // 确保sort是有效数字
              const sortValue = Number(item.sort)
              if (!isNaN(sortValue) && sortValue < minSort) {
                minSort = sortValue
              }
            })
            
            // 获取当前商品的排序号
            const currentSort = Number(row.sort)
            
            // 如果找到了最小排序号，且当前商品不是最小排序号，则更新排序
            if (minSort !== Infinity && !isNaN(currentSort) && currentSort !== minSort) {
              const newSort = minSort - 1
              // 先执行推荐操作，然后更新排序
              return recommendPromise.then(() => {
                // 根据商品类型选择不同的排序接口
                if (row.type === 3) {
                  return liveManageApi.updateLiveActivitySort({ id: row.id, sort: newSort })
                } else {
                  return liveManageApi.updateLiveGoodsSort(this.mountParams(row, { id: row.id, sort: newSort }))
                }
              })
            } else {
              // 如果当前商品本身就是最小排序号，或者没有找到最小排序号，只执行推荐操作
              return recommendPromise
            }
          }
          
          // 取消推荐时，只执行推荐操作
          return recommendPromise
        })
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ })
        })
        .catch(error => {
          console.error('推荐操作失败:', error)
          this.$common.showMsg('error', '操作失败')
        })
    },
    handleDelete(row) {
      if (row.type === 4 && !this.canManageIntent) return
      this.$common.confirm('是否确认删除')
        .then(() => {
          // 根据商品类型选择不同的删除接口
          if (row.type === 3) {
            // 充值活动使用 livetuition-delete 接口
            return liveManageApi.deleteLiveTuitionById({ id: row.id })
          } else {
            // 普通商品使用 livegoods-delete 接口
            return liveManageApi.deleteLiveGoodsById(this.mountParams(row, { id: row.id }))
          }
        })
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ })
        })
        .catch(error => {
          console.error('删除操作失败:', error)
          this.$common.showMsg('error', '删除失败')
        })
    },
    handleDown(row) {
      if (row.type === 4 && !this.canManageIntent) return
      if (row.state) {
        // 下架操作 - 弹出确认弹窗
        this.$common.confirm('是否下架商品？')
          .then(() => {
            let Ins = row.type === 3? liveManageApi.updateLiveActivitySetoff : liveManageApi.updateLiveGoodsSetoff
            return Ins(this.mountParams(row, { id: row.id }))
          })
          .then(() => {
            this.$common.showMsg('success', '下架成功')
            return this.doQueryList({ pageNo: 1 })
          })
      } else {
        // 上架操作 - 弹出设置弹窗
        this.goodsItem = row
        if (row.type === 4) this.form = { ...initFormBean(), goodsType: 4, intentConfigId: row.intentConfigId, showTime: row.showTime, canBuy: row.canBuy ? 1 : 0, state: 1 }
        this.modelType = 0
        this.formVisible = true
      }
    },
    updateLiveGoods(row) {
      // 弹出输入框让用户输入新的虚拟销售量
      this.$prompt('请输入新的虚拟销售量', '修改虚拟销售量', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.salesCount || 0,
        inputPattern: /^[0-9]+$/,
        inputErrorMessage: '虚拟销售量必须为非负整数',
      }).then(({ value }) => {
        // 确保salesCount是数字类型
        const salesCount = parseInt(value) || 0
        // 调用更新虚拟销售量接口
        return liveManageApi.updateLiveGoods({ id: row.id, salesCount })
      }).then(() => {
        this.$common.showMsg('success', '修改虚拟销售量成功')
        return this.doQueryList()
      }).catch(error => {
        if (error !== 'cancel') {
          console.error('修改虚拟销售量失败:', error)
          this.$common.showMsg('error', '修改虚拟销售量失败')
        }
      })
    },
    updateLiveTuition(row) {
      // 弹出输入框让用户输入新的剩余名额
      this.$prompt('请输入新的剩余名额', '修改剩余名额', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.remainingQuota || 0,
        inputPattern: /^[0-9]+$/,
        inputErrorMessage: '剩余名额必须为非负整数',
      }).then(({ value }) => {
        // 确保remainingQuota是数字类型
        const remainingQuota = parseInt(value) || 0
        // 调用更新剩余名额接口
        return liveManageApi.updateLiveTuition({ id: row.id, remainingQuota })
      }).then(() => {
        this.$common.showMsg('success', '修改剩余名额成功')
        return this.doQueryList()
      }).catch(error => {
        if (error !== 'cancel') {
          console.error('修改剩余名额失败:', error)
          this.$common.showMsg('error', '修改剩余名额失败')
        }
      })
    },
    updateSort(row) {
      if (row.type === 4 && !this.canManageIntent) return
      // 弹出输入框让用户输入新的排序值
      this.$prompt('请输入新的排序值', '修改排序', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.sort,
        inputPattern: /^[0-9]+$/,
        inputErrorMessage: '排序值必须为正整数',
      }).then(({ value }) => {
        // 确保sort是数字类型
        const sort = parseInt(value) || 0
        // 根据商品类型选择不同的API
        if (row.type === 3) {
          // 充值活动使用 livetuition-sort 接口
          return liveManageApi.updateLiveActivitySort({ id: row.id, sort })
        } else {
          // 普通商品使用 livegoods-sort 接口
          return liveManageApi.updateLiveGoodsSort(this.mountParams(row, { id: row.id, sort }))
        }
      }).then(() => {
        this.$common.showMsg('success', '修改排序成功')
        return this.doQueryList()
      }).catch(error => {
        if (error !== 'cancel') {
          console.error('修改排序失败:', error)
          this.$common.showMsg('error', '修改排序失败')
        }
      })
    },
    updateLiveGoodsSeton() {
      if (this.goodsItem.type === 4 && !this.canManageIntent) { this.isRepSub = false; return }
      let { showTime, canBuy, state } = this.form
      // 确保showTime是数字类型
      if (showTime) {
        showTime = parseInt(showTime) || 0
      }
      let params = { id: this.goodsItem.id, canBuy, showTime, state }
      let Ins = this.goodsItem.type === 3? liveManageApi.updateLiveActivitySeton : liveManageApi.updateLiveGoodsSeton
      Ins(params).then((data) => {
        this.postCallback(data)
      }).catch(res => {
        this.isRepSub = false
      });
    },
    removeAdmin(idx) {
      // 这里写移除逻辑
      this.adminList.splice(idx, 1)
    },
    doCreate() {
      if (this.form.goodsType === 4) return this.createIntentGoods()
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.modelType === 0) return this.updateLiveGoodsSeton()
          // 设置直播ID到表单中
          this.form.liveId = this.rowItem.livePO.id
          // 确保showTime是数字类型
          if (this.form.showTime) {
            this.form.showTime = parseInt(this.form.showTime) || 0
          }
          // 设置onTime为当前时间
          const now = new Date()
          const year = now.getFullYear()
          const month = String(now.getMonth() + 1).padStart(2, '0')
          const day = String(now.getDate()).padStart(2, '0')
          const hours = String(now.getHours()).padStart(2, '0')
          const minutes = String(now.getMinutes()).padStart(2, '0')
          const seconds = String(now.getSeconds()).padStart(2, '0')
          this.form.onTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
          liveManageApi.createLiveGoods(this.form).then((data) => {
            this.postCallback(data)
            liveManageApi.clearLiveGoodsCache({ liveId: this.rowItem.livePO.id })
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      // 关闭添加商品弹窗
      this.formVisible = false;
      // 不关闭商品列表弹窗，保持显示
      // this.visible 保持为 true
      // 刷新商品列表数据
      this.doQueryList()
      this.$emit('created')
    },
    async createIntentGoods() {
      if (!this.canManageIntent || this.isRepSub) return
      if (this.modelType === 1 && (!this.intentLoaded || !this.selectedIntent || !/^[1-9]\d*$/.test(String(this.form.linkId)) || !Number.isSafeInteger(Number(this.form.linkId)))) { this.$message.warning('请先读取并选择启用配置，填写正整数链接编号'); return }
      if (this.form.showTime !== null && this.form.showTime !== '' && (!/^[1-9]\d*$/.test(String(this.form.showTime)) || !Number.isSafeInteger(Number(this.form.showTime)))) { this.$message.warning('上架持续时间需为正整数分钟，或留空'); return }
      if (!/^\d+$/.test(String(this.form.sort)) || !Number.isSafeInteger(Number(this.form.sort))) { this.$message.warning('排序必须为非负整数'); return }
      if (![0, 1].includes(this.form.canBuy) || ![0, 1].includes(this.form.state)) { this.$message.warning('请确认购买权限与上下架状态'); return }
      this.isRepSub = true
      try {
        const data = { liveId: this.rowItem.livePO.id, goodsType: 4, intentConfigId: this.form.intentConfigId, linkId: Number(this.form.linkId), showTime: this.form.showTime === '' || this.form.showTime == null ? null : Number(this.form.showTime), sort: Number(this.form.sort), state: this.form.state, canBuy: this.form.canBuy }
        const res = this.modelType === 1 ? await liveManageApi.createLiveGoods(data) : await liveManageApi.updateLiveGoodsSeton({ id: this.goodsItem.id, goodsType: 4, showTime: data.showTime, state: data.state, canBuy: data.canBuy })
        if (!res || String(res.code) !== '0') throw new Error((res && (res.message || res.msg)) || '意向金挂载失败')
        this.formVisible = false; this.$message.success('意向金直播商品已保存'); await this.doQueryList(); this.$emit('created')
        try { const cache = await liveManageApi.clearLiveGoodsCache({ liveId: this.rowItem.livePO.id }); if (!cache || String(cache.code) !== '0') throw new Error('刷新失败'); this.$message.success('APP 直播商品展示已刷新') } catch (_) { this.$message.warning('挂载已保存，展示刷新失败，请重试清除直播商品缓存') }
      } catch (e) { this.$message.error(e.message || '意向金挂载失败，请核对当前配置') }
      finally { this.isRepSub = false }
    },
    handleRemoveActivity(row) {
      this.$common.confirm('确认移除该充值活动？')
        .then(() => {
          // 这里需要调用移除接口，暂时用删除商品接口代替
          return liveManageApi.deleteLiveGoods({ id: row.id })
        })
        .then(() => {
          this.$common.showMsg('success', '移除成功')
          this.doQueryList()
        })
    },
    clearLiveGoodsCache() {
      this.$common.confirm('确认清除直播商品缓存？')
        .then(() => {
          return liveManageApi.clearLiveGoodsCache({ liveId: this.rowItem.livePO.id })
        })
        .then(() => {
          this.$common.showMsg('success', '清除缓存成功')
        })
        .catch((error) => {
          console.error('清除缓存失败:', error)
          this.$common.showMsg('error', '清除缓存失败')
        })
    },
  }
}
</script>

<style scoped>
.tip-red {
  color: #f56c6c;
  font-weight: 600;
}
.action-link {
  padding-right: 5px;
  padding-left: 5px;
}
.dialog-content-wrapper {
  max-height: 70vh;
  overflow-y: auto;
}
.table-wrapper {
  overflow-x: auto;
}
</style>
<style>
.live-goods-dialog .el-dialog__body {
  padding: 20px;
  max-height: calc(80vh - 120px);
  overflow-y: auto;
}
</style>
